var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    fill: "#053A7A",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 48.0312C39.2562 48.0312 39.0125 48.0312 38.8906 47.9094L32.7969 44.2531C32.4312 44.0094 32.1875 43.6438 32.1875 43.1562V35.8438C32.1875 35.3562 32.4312 34.9906 32.7969 34.7469L38.8906 31.0906C39.0125 30.9688 39.2562 30.9688 39.5 30.9688C39.7438 30.9688 39.9875 30.9688 40.1094 31.0906L46.2031 34.7469C46.5688 34.9906 46.8125 35.3562 46.8125 35.8438V43.1562C46.8125 43.6438 46.5688 44.0094 46.2031 44.2531L40.1094 47.9094C39.9875 48.0312 39.7438 48.0312 39.5 48.0312ZM34.625 42.425L39.5 45.35L44.375 42.425V36.4531L39.5 33.5281L34.625 36.4531V42.425Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 57.7812C39.2563 57.7812 39.1344 57.7812 38.8906 57.6594L24.2656 49.1281C23.9 48.8844 23.6562 48.5187 23.6562 48.0312V30.9688C23.6562 30.4812 23.9 30.1156 24.2656 29.8719L38.8906 21.3406C39.1344 21.2188 39.2563 21.2188 39.5 21.2188C39.7437 21.2188 39.8656 21.2188 40.1094 21.3406L54.7344 29.8719L53.5156 31.9438L39.5 23.9L26.0938 31.7V47.4219L39.5 55.2219L52.9062 47.4219V38.2812H55.3438V48.0312C55.3438 48.5187 55.1 48.8844 54.7344 49.1281L40.1094 57.6594C39.8656 57.7812 39.7437 57.7812 39.5 57.7812Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMision);
export default __webpack_public_path__ + "static/media/mision.b183694b444d31ab794deb16e04a3069.svg";
export { ForwardRef as ReactComponent };